import Image from "next/image";
import React, { useRef } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { Icon } from "@iconify/react/dist/iconify.js";
import Title from "@/components/ui/Title";

const Reviews = () => {
  const sliderRef = useRef<Slider>(null);

  const handleNext = () => {
    if (sliderRef.current) {
      sliderRef.current.slickNext();
    }
  };

  const handlePrev = () => {
    if (sliderRef.current) {
      sliderRef.current.slickPrev();
    }
  };
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 4000,
    arrows: false,
    dotsClass: "slick-dots custom-dots", // Add a custom class

    // pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <main className=" bg-testimonial h-screen  flex justify-center items-center  bg-cover bg-center relative  ">
      <div className="absolute top-0 left-0 w-full h-full bg-black opacity-[0.7]"></div>

      <div className="lg:w-11/12 w-11/12 3xl:w-8/12 mx-auto z-[50] ">
        <div className="grid md:grid-cols-2 grid-cols-1  md:gap-8 py-4">
          <div className="flex flex-col  home-about-title justify-center gap-2">
            <div className="md:w-[90%] flex-col flex gap-2 justify-start items-start">
              <h2 className="uppercase font-extrabold title lg:text-[2.5em] leading-[1em] sm:text-[1.5em] text-2xl text-white">
                Testimonials
              </h2>

              <p className="text-white  desc md:text-lg text-sm py-2 leading-relaxed">
                We’re proud to have helped countless adventurers create memories
                that last a lifetime.Read their stories of discovery, trust, and
                joy, and see why we’re the go-to choice for travelers worldwide.
                Your next adventure could be your best one yet just like it was
                for them.
              </p>
            </div>

            {/* arrows */}
            <div className="flex text-2xl items-center gap-2 md:mt-4">
              <button
                onClick={handlePrev}
                className="cursor-pointer outline-none border rounded-full bg-black  hover:scale-95 ease-in-out duration-200 shadow-sm p-2"
              >
                <Icon
                  icon="iconamoon:arrow-left-2"
                  style={{ color: "white" }}
                />
              </button>
              <button
                onClick={handleNext}
                className="cursor-pointer outline-none border rounded-full bg-black  hover:scale-95  ease-in-out duration-200 shadow-sm p-2"
              >
                <Icon
                  icon="iconamoon:arrow-right-2"
                  style={{ color: "white" }}
                />
              </button>
            </div>
          </div>

          <div className="relative py-8">
            <Slider {...settings} ref={sliderRef}>
              {reviewsData.map((item, index) => (
                <div key={index} className="cursor-pointer  pb-4 px-2">
                  <div className="bg-white grid border-4 border-primary2/80 min-h-[22vw] lg:w-[40vw] p-6 rounded-2xl mx-auto relative">
                  <Icon icon="ooui:quotes-ltr"  style={{color: "black"}} className="absolute left-4 md:text-8xl text-5xl opacity-5 " />
                  <Icon icon="ooui:quotes-rtl"  style={{color: "black"}}  className="absolute right-4 bottom-0 md:text-8xl text-5xl opacity-5 "  />
                  <div className="flex flex-col justify-center text-center items-center">
                      <Image
                        src={item.img}
                        width={1000}
                        height={1000}
                        alt="avatars"
                        className="w-16 h-16 rounded-full object-cover border-2 border-green-500"
                      />
                      <div className="my-2">
                        <h2 className="font-bold md:text-2xl text-sm">
                          {item.name}
                        </h2>
                        <p className="font-medium md:text-lg italic text-xs mt-2">
                          {item.position}
                        </p>
                      </div>
                      <div className="flex justify-center  md:text-[1.4vw]">
                      {[...Array(5)].map((_, i) => (
                        <Icon
                          key={i}
                          icon="ic:sharp-star"
                          style={{ color: "#f19620" }}
                        />
                      ))}
                    </div>
                    </div>
                    <p className="mb-4 text-light text-center  md:text-lg text-xs leading-6 md:w-[80%] mx-auto">
                      {item.reviewDescription}
                    </p>
                   
                  </div>
                </div>
              ))}
            </Slider>
            {/* <div className="absolute top-0 left-0 h-full bg-gradient-to-r w-[10vw] from-zinc-50 to-transparent z-10"></div>
          <div className="absolute top-0 right-0 h-full bg-gradient-to-l w-[10vw] from-zinc-50 to-transparent z-10"></div> */}
          </div>
        </div>
      </div>
    </main>
  );
};

export default Reviews;

const reviewsData = [
  {
    id: 1,
    reviewText: "Incredible cultural immersion experience",
    reviewDescription:
      "Their guided tours offered us the perfect mix of adventure and education. From exploring ancient ruins to trying local cuisine, it was unforgettable!",
    name: "John D",
    position: "Travel Enthusiast",
    img: "/avatar.jpg",
  },
  {
    id: 2,
    reviewText: "A dream vacation come true",
    reviewDescription:
      "The attention to detail in planning our trip was phenomenal. Every destination, from mountain hikes to seaside retreats, was perfectly curated.",
    name: "Jane Smith",
    position: "Luxury Traveler",
    img: "/avatar.jpg",
  },
  {
    id: 3,
    reviewText: "Seamless and unforgettable adventure",
    reviewDescription:
      "Our journey through remote villages and hidden gems was incredible. The guides were knowledgeable, and every day felt like a new adventure.",
    name: "Michael Brown",
    position: "Adventure Seeker",
    img: "/avatar.jpg",
  },
  {
    id: 4,
    reviewText: "Perfect balance of relaxation and excitement",
    reviewDescription:
      "From thrilling excursions to peaceful beach days, the itinerary was flawless. I can't recommend their travel packages enough!",
    name: "Emily White",
    position: "Explorer",
    img: "/avatar.jpg",
  },
];
